import React from "react"
import FieldProto from "../proto/field-proto";
import {FieldViewSize} from "../const"
import {ToggleSize} from "../generic/boolean/toggle/components/toggle-statefull";

export type FieldFormElementViewOptions = {

    size?               : '36' | '30' | ToggleSize | '28' | 28 | '16' // form element size
    showIcon?           : boolean  // i  guess hsow icon in dropdowns etc
    hideLabel?          : boolean // no idea

    format?             : string    // i guess date format ?
    autofocus?          : boolean   // focus on render

    attachment?         : string    // i guess drop down popover attachment
    targetAttachment?   : string    // i guess drop down popover attachment
}

export type FieldFormElementViewProps = {
    className?  : string

    size?       : FieldViewSize // I THINK THIS ONE SHOULD BE DEPRECATED

    field       : FieldProto
    model       : any
    options?    : FieldFormElementViewOptions //any // size, showIcon - we need options type...

    disabled?   : boolean

    onChange?   : callback
    onEnter?    : callback          // use it when we want to submit form on enter click EXPERIMETNAL

    rows?       : number        // used in text area - number of rows
}

export default function FieldFormElementView(props:FieldFormElementViewProps):any {

    let disabled    = false

    if (!_.isNil(props.disabled)) { // check if disabled property is overridden
        disabled = props.disabled
    } else if (props.field.isDisabled) {
        disabled = true
    } else {
        switch (props.field.access(props.model)) {
            case false      :
                return false
            case 'read'     :
                disabled = true   // po idee eto auto disable sdelaet dlya read only fields
                break
            case 'write'    :
                break
        }
    }

    return <props.field.renderComponents.formElementView className  = {props.className}
                                                         field      = {props.field}
                                                         options    = {props.options}
                                                         model      = {props.model}
                                                         size       = {props.size}
                                                         onEnter    = {props.onEnter}   // experimenta
                                                         disabled   = {disabled}
                                                         rows       = {props.rows}
                                                         onChange   = {props.onChange}/>

}
